import Typography from '@mui/material/Typography';
import React from 'react';

export const EmptyFieldValueRenderer: React.FC = (): React.ReactElement => {
  return (
    <Typography component="span" color="custom.LightGray">
      &mdash;
    </Typography>
  );
};
